module.exports = __webpack_public_path__ + "Roboto-Medium.894a2ede85a483bf9bed.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Medium.ttf
// module id = ../../../../../font/roboto/Roboto-Medium.ttf
// module chunks = styles